module.exports = new __parcel__URL__("arrow-left-mismatch.14c5dc32.svg").toString();